export const filterSelector = state => state.filter.toJS()
